import { render } from "./DashboardAdmin.vue?vue&type=template&id=8dc592b4"
const script = {}

import "./DashboardAdmin.vue?vue&type=style&index=0&id=8dc592b4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__